import { render, staticRenderFns } from "./page.vue?vue&type=template&id=d1fd59ec&scoped=true&"
var script = {}
import style0 from "./page.vue?vue&type=style&index=0&id=d1fd59ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fd59ec",
  null
  
)

component.options.__file = "page.vue"
export default component.exports